import React from 'react'
import './intro.css'
import { Box, Button } from "@mui/material";
import { useThemeContext } from "../../../../Context/ThemeContext.js";
import { DARKCOLORS, LIGHTCOLORS } from "../../../../Utils/constants.js";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';

import { useEffect } from 'react';

const Intro = () => {
    const { mode } = useThemeContext();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const containerBG = mode === "dark" ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
    const btnBG = mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const spancolor = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const headingcolor2 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;

     useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    return (
        <div className=' intro-container' >
            <div className="faq-sec">
                <Box className="">
                    <Box className=''>
                        <h1 className="intro-title" style={{ color: headingcolor }}> {t('help.introTitle')}</h1>
                        <p className="intro-sub-title" style={{ color: subtitletext }}>{t('help.introTitleText')}</p>
                        <p className="key-features-functionality" style={{ color: headingcolor }}>{t('help.introSubTitle')}</p>

                        <p className="intro-sub-title" style={{ color: subtitletext }}>{t('help.introSubTitleText')}</p>


                    </Box>
                    <Box className="real-time-Monitoring heading-spacing">

                        <ol className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading '>{t('help.RealtimeMonitoringandAnalytics')} </li>
                        </ol>
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">

                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('help.RealtimeMonitoringandAnalyticsPoint1bold')} </span> {t('help.RealtimeMonitoringandAnalyticsPoint1Text')}</li>

                            <li style={{ color: subtitletext }} className="terms-subli disk "> <span className='terms-span sublist ' style={{ color: headingcolor2 }}>{t('help.RealtimeMonitoringandAnalyticsPoint2bold')} </span> {t('help.RealtimeMonitoringandAnalyticsPoint2Text')}</li>

                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist ' style={{ color: headingcolor2 }}>{t('help.RealtimeMonitoringandAnalyticsPoint3bold')} </span>{t('help.RealtimeMonitoringandAnalyticsPoint3Text')}</li>

                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist ' style={{ color: headingcolor2 }}>{t('help.RealtimeMonitoringandAnalyticsPoint4bold')}  </span>{t('help.RealtimeMonitoringandAnalyticsPoint4Text')}</li>

                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist ' style={{ color: headingcolor2 }}>{t('help.RealtimeMonitoringandAnalyticsPoint5bold')} </span>{t('help.RealtimeMonitoringandAnalyticsPoint5Text')}</li>
                        </ul>
                    </Box>
                    <Box className="stock-Management heading-spacing" > 
                        <ol start={2} className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'>{t('help.stockManagement')} </li>
                        </ol> 
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">

                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('help.stockManagementIssuePoint1bold')}</span> {t('help.stockManagementIssuePoint1Text')}</li>

                           
                        </ul>
                        
                        
                    </Box>
                    <Box className="advertisment-box heading-spacing" > 
                        <ol start={3} className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'> {t('help.addvPromotion')}</li>
                        </ol> 
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">

                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('help.addvPromotionPoint1bold')}</span> {t('help.addvPromotionPoint1Text')}</li>

                        </ul>
                    </Box>
                    <Box className="advertisment-box heading-spacing" > 
                        <ol start={4} className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'> {t('help.crm')}</li>
                        </ol> 
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">

                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('help.crmPoint1bold')} </span> {t('help.crmPoint1Text')}</li>
                        </ul>
                    </Box>
                    <Box className=" Discount-Coupon-box heading-spacing" >
                        <ol start={5} className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'>{t('help.helpdiscountCoupons')}</li>
                        </ol> 
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">
                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}> {t('help.helpdiscountCouponsPoint1bold')}</span>  {t('help.helpdiscountCouponsPoint1Text')}</li>
                        </ul>
                    </Box>
                    <Box className=" proactive-box heading-spacing" >
                        <ol start={6} className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'>{t('help.maintenanceandServiceRequests')}</li>
                        </ol> 
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">
                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}> {t('help.maintenanceandServiceRequestsPoint1bold')}</span>  {t('help.maintenanceandServiceRequestsPoint1Text')}</li>
                        </ul>
                    </Box>
                    <Box className=" proactive-box heading-spacing">
                        <ol className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'>{t('help.FranchiseManagement')}</li>
                        </ol>
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">
                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}> {t('help.FranchiseManagementPoint1bold')}</span>  {t('help.FranchiseManagementPoint1Text')}</li>
                        </ul>
                    </Box>
                    <Box className=" proactive-box heading-spacing" >
                        <ol start={8} className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'>{t('help.secureUserAccessandPermissions')}</li>
                        </ol>
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">
                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}> {t('help.secureUserAccessandPermissionsPoint1bold')} </span>{t('help.secureUserAccessandPermissionsPoint1Text')}</li>
                        </ul>
                    </Box>
                    <Box className=" proactive-box heading-spacing" sx={{marginBottom:'50px'}} >
                        <ol start={9} className='ol-heading'>
                            <li style={{color:headingcolor,fontWeight:'600'}} className='intro-heading'>{t('help.taxReporting')}</li>
                        </ol>
                        <ul style={{ marginTop: '10px',lineHeight:'2em' }} className="terms-subol">
                            <li style={{ color: subtitletext }} className="terms-subli disk"> <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('help.taxReportingPoint1bold')}  </span>{t('help.taxReportingPoint1Text')}</li>
                        </ul>
                    </Box>




                </Box>
            </div>


        </div>

    )
}

export default Intro